import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as InfoCircle } from 'assets/images/info-circle-fine.svg';

interface TagProps {
  activeColor: boolean;
}

const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const StyledFloaterRounded = styled.span.attrs<any, TagProps>((): any => {})`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid ${({activeColor, theme}) => (activeColor ? '#ccc' : hexToRgba(theme.primaryBackgroundColor, 0.20))};
  overflow: hidden;
  margin-right: 16px;
  background-color: ${({activeColor, theme}) => (activeColor ? '#e7e7e7' : hexToRgba(theme.primaryBackgroundColor, 0.08))};
`;

export const StyledFloater = styled.span`
  display: inline-block;

  & span {
    display: inline-block;
  }
`;

export const TooltipBaloon = styled.div`
  max-width: 90vw;
  display: flex;
  align-items: center;
  padding: 20px;
  background-image: linear-gradient(73deg, ${ColorPalette.HEX.DimGray} 0%, ${ColorPalette.HEX.CharlestonGreen} 100%);
  color: ${ColorPalette.HEX.White};
  border-radius: 12px;
`;

export const InfoCircleIcon = styled(InfoCircle)`
  width: 24px;
  height: 24px;
  margin-right: 20px;
  flex-shrink: 0;
`;

export const Content = styled.div`
  padding-right: 40px;
  flex: 1;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
  color: ${ColorPalette.HEX.White};
`;
